export const createWebVitalsFilter = (hasNavigated = () => false) => {
  const reported = new Set<string>();
  let pageCount = 0;

  return (event: string | undefined) => {
    if (event === "pageData") {
      pageCount += 1;
    }

    if (event !== "firstContentfulPaint" && event !== "timeToFirstByte") {
      return true;
    }

    if (hasNavigated() || pageCount > 1 || reported.has(event)) {
      return false;
    }

    reported.add(event);
    return true;
  };
};
